<!--
  TRANSFER — scheda di creazione, con lo stesso impianto della scheda
  Pickup & Delivery.

  Cosa ha di diverso dal Pickup:

  - LA SECONDA SCHERMATA ESISTE SOLO SE il cliente paga lavori di officina
    (`task == 'true'`): lo decide `handleButtonClickCrea`, che altrimenti
    crea subito, quindi la striscia delle schermate compare solo in quel caso.
  - L'auto serve solo per i lavori di officina, e sta lì.
-->
<template>
  <div class="servizio-wrap fx">
    <!-- ---------- le schermate della scheda ----------
         Senza numeri: la pagina che ospita la scheda numera gia' i suoi passi.
         Vedi la nota in PickupComponent. -->
    <nav
      v-if="task == 'true' || active === 1"
      class="fx__flow"
      aria-label="Schermate della scheda"
    >
      <span
        class="fx__flowStep"
        :class="{ 'is-on': active === 0 }"
        :aria-current="active === 0 ? 'step' : undefined"
      >Prenotazione</span>
      <span
        class="fx__flowSep"
        aria-hidden="true"
      >›</span>
      <span
        class="fx__flowStep"
        :class="{ 'is-on': active === 1 }"
        :aria-current="active === 1 ? 'step' : undefined"
      >Lavori e allegati</span>
    </nav>

    <!-- ================= PASSO 1 ================= -->
    <template v-if="active === 0">
      <!-- ---------- cliente e sede ---------- -->
      <section class="form-card">
        <header class="form-card__head">
          <h3>Cliente e sede</h3>
          <div class="form-card__spacer" />
          <AddNewCustomerComponent servizio="escort" />
        </header>

        <div class="form-card__body">
          <div class="container-customer">
            <div>
              <PointComponent
                :value="customerExist"
                title="Cerca cliente per email"
                label="email"
                placeholder="email"
                @input="(newValue) => (customerExist = newValue)"
              />
            </div>
            <div>
              <ButtonComponent
                label="cerca"
                :is-router="false"
                @button-click="checkCustomerExist"
              />
            </div>
          </div>

          <div class="flex-container">
            <div class="select-component">
              <SelectComponent
                :options="customersId"
                title="Cliente"
                :add-buttom="false"
                :highlight="highlightCustomer"
                :is-disabled="false"
                :value="customerSelected"
                @selected="handleChangeCustomer"
              />
            </div>
            <div class="select-component">
              <SelectComponent
                :options="headquartersId"
                title="Sede"
                :add-buttom="false"
                :highlight="highlightHeadquarter"
                :is-disabled="false"
                :value="headquarterSelected"
                @selected="handleChangeHeadquarter"
              />
            </div>
          </div>

          <!-- Era «Verrà fornita l'auto al driver per accompagna il cliente al
               punto stabilito», su una riga a se' fra due divisori. -->
          <p class="fx-note">
            Al driver verrà fornita l'auto per accompagnare il cliente al punto
            stabilito.
          </p>
        </div>
      </section>

      <!-- ---------- andata ---------- -->
      <section
        class="form-card"
        :class="{ 'is-off': !is_gone }"
      >
        <header class="form-card__head">
          <el-switch
            v-model="is_gone"
            :active-value="true"
            :inactive-value="false"
            aria-label="Includi l'andata"
          />
          <h3>Andata</h3>
        </header>

        <div
          v-if="is_gone"
          class="form-card__body"
        >
          <el-form :model="escort_gone">
            <div class="container-data">
              <DateSelectComponent
                title="Data di partenza dalla sede"
                slot-title="Fascia oraria"
                :selected-date="dataIniziale"
                :loading="loadingSlotsGone"
                :time-slots="timeSlotsGone"
                :highlight-slot="highlightSlotGone"
                :date-disabled="!customerSelected || !headquarterSelected"
                :highlight-date="highlightDateGone"
                :selected-slot-input="selectedSlotGone"
                :disabled-dates="disabledDate"
                @selected-slot="handleSlotChangeGone"
                @date-partner-change="handleChangeDateGone"
              />
            </div>

            <div class="container-point">
              <PointComponent
                :value="escort_gone.point_origin_escort.address"
                title="Indirizzo di prelievo"
                label="Indirizzo"
                placeholder="Indirizzo"
                :disabled="booking.loaner == 'true'"
                @input="(newValue) => (escort_gone.point_origin_escort.address = newValue)"
                @focus="handleInputFocusGone"
                @blur="handleInputBlurGone"
              />
              <PointComponent
                :value="escort_gone.point_origin_escort.street_number"
                title="Civico"
                label="N. civico"
                placeholder="N. civico"
                :disabled="booking.loaner == 'true'"
                @input="(newValue) => (escort_gone.point_origin_escort.street_number = newValue)"
                @focus="handleInputFocusGone"
                @blur="handleInputBlurGone"
              />
              <PointComponent
                :value="escort_gone.point_origin_escort.cap"
                title="CAP"
                label="CAP"
                placeholder="CAP"
                :disabled="booking.loaner == 'true'"
                @input="(newValue) => (escort_gone.point_origin_escort.cap = newValue)"
                @focus="handleInputFocusGone"
                @blur="handleInputBlurGone"
              />
              <PointComponent
                :value="escort_gone.point_origin_escort.city"
                :span="4"
                title="Città"
                label="Città"
                placeholder="Città"
                :disabled="booking.loaner == 'true'"
                @input="(newValue) => (escort_gone.point_origin_escort.city = newValue)"
                @focus="handleInputFocusGone"
                @blur="handleInputBlurGone"
              />
              <PointComponent
                :value="escort_gone.point_origin_escort.province"
                title="Provincia"
                label="Provincia"
                placeholder="Provincia"
                :disabled="booking.loaner == 'true'"
                @input="(newValue) => (escort_gone.point_origin_escort.province = newValue)"
                @focus="handleInputFocusGone"
                @blur="handleInputBlurGone"
              />
            </div>
            <DescriptionComponent
              :label="escort_gone.point_origin_escort.label"
              :loading="loadingPoint"
            />

            <div class="container-point">
              <PointComponent
                :value="escort_gone.point_destination_escort.address"
                title="Indirizzo di consegna"
                label="Indirizzo"
                placeholder="Indirizzo"
                :span="8"
                @input="(newValue) => (escort_gone.point_destination_escort.address = newValue)"
                @focus="handleInputFocusGone"
                @blur="handleInputBlurGone"
              />
              <PointComponent
                :value="escort_gone.point_destination_escort.street_number"
                title="Civico"
                label="N. civico"
                placeholder="N. civico"
                @input="(newValue) => (escort_gone.point_destination_escort.street_number = newValue)"
                @focus="handleInputFocusGone"
                @blur="handleInputBlurGone"
              />
              <PointComponent
                :value="escort_gone.point_destination_escort.cap"
                title="CAP"
                label="CAP"
                placeholder="CAP"
                @input="(newValue) => (escort_gone.point_destination_escort.cap = newValue)"
                @focus="handleInputFocusGone"
                @blur="handleInputBlurGone"
              />
              <PointComponent
                :value="escort_gone.point_destination_escort.city"
                :span="4"
                title="Città"
                label="Città"
                placeholder="Città"
                @input="(newValue) => (escort_gone.point_destination_escort.city = newValue)"
                @focus="handleInputFocusGone"
                @blur="handleInputBlurGone"
              />
              <PointComponent
                :value="escort_gone.point_destination_escort.province"
                title="Provincia"
                label="Provincia"
                placeholder="Provincia"
                @input="(newValue) => (escort_gone.point_destination_escort.province = newValue)"
                @focus="handleInputFocusGone"
                @blur="handleInputBlurGone"
              />
            </div>
            <DescriptionComponent
              :label="escort_gone.point_destination_escort.label"
              :loading="loadingPoint"
            />

            <div class="fx-stats">
              <span class="fx-stat">
                <span class="fx-stat__l">Fascia km</span>
                <span class="fx-stat__v">{{ kmTesto(responseKmGone) }}</span>
              </span>
              <span class="fx-stat fx-stat--euro">
                <span class="fx-stat__l">Tariffa</span>
                <span class="fx-stat__v">{{ euroTesto(responseCostGone) }}</span>
              </span>
            </div>
          </el-form>
        </div>

        <div
          v-else
          class="form-card__off"
        >
          Non inclusa in questa prenotazione. Accendila con l'interruttore.
        </div>
      </section>

      <!-- ---------- ritorno ---------- -->
      <section
        class="form-card"
        :class="{ 'is-off': !is_return }"
      >
        <header class="form-card__head">
          <el-switch
            v-model="is_return"
            :active-value="true"
            :inactive-value="false"
            aria-label="Includi il ritorno"
          />
          <h3>Ritorno</h3>
        </header>

        <div
          v-if="is_return"
          class="form-card__body"
        >
          <el-form :model="escort_return">
            <div class="container-data">
              <DateSelectComponent
                title="Data di arrivo del driver"
                slot-title="Fascia oraria"
                :loading="loadingSlotsReturn"
                :time-slots="timeSlotsReturn"
                :highlight-slot="highlightSlotReturn"
                :date-disabled="!customerSelected || !headquarterSelected"
                :highlight-date="highlightDateReturn"
                :selected-slot-input="selectedSlotReturn"
                :disabled-dates="disabledDateReturn"
                @selected-slot="handleSlotChangeReturn"
                @date-partner-change="handleChangeDateReturn"
              />
            </div>

            <div class="container-point">
              <PointComponent
                :value="escort_return.point_origin_escort.address"
                title="Indirizzo di prelievo"
                label="Indirizzo"
                placeholder="Indirizzo"
                @input="(newValue) => (escort_return.point_origin_escort.address = newValue)"
                @focus="handleInputFocusReturn"
                @blur="handleInputBlurReturn"
              />
              <PointComponent
                :value="escort_return.point_origin_escort.street_number"
                title="Civico"
                label="N. civico"
                placeholder="N. civico"
                @input="(newValue) => (escort_return.point_origin_escort.street_number = newValue)"
                @focus="handleInputFocusReturn"
                @blur="handleInputBlurReturn"
              />
              <PointComponent
                :value="escort_return.point_origin_escort.cap"
                title="CAP"
                label="CAP"
                placeholder="CAP"
                @input="(newValue) => (escort_return.point_origin_escort.cap = newValue)"
                @focus="handleInputFocusReturn"
                @blur="handleInputBlurReturn"
              />
              <PointComponent
                :value="escort_return.point_origin_escort.city"
                :span="4"
                title="Città"
                label="Città"
                placeholder="Città"
                @input="(newValue) => (escort_return.point_origin_escort.city = newValue)"
                @focus="handleInputFocusReturn"
                @blur="handleInputBlurReturn"
              />
              <PointComponent
                :value="escort_return.point_origin_escort.province"
                title="Provincia"
                label="Provincia"
                placeholder="Provincia"
                @input="(newValue) => (escort_return.point_origin_escort.province = newValue)"
                @focus="handleInputFocusReturn"
                @blur="handleInputBlurReturn"
              />
            </div>
            <DescriptionComponent
              :label="escort_return.point_origin_escort.label"
              :loading="loadingPoint"
            />

            <div class="container-point">
              <PointComponent
                :value="escort_return.point_destination_escort.address"
                title="Indirizzo di consegna"
                label="Indirizzo"
                placeholder="Indirizzo"
                :disabled="booking.loaner == 'true'"
                :span="8"
                @input="(newValue) => (escort_return.point_destination_escort.address = newValue)"
                @focus="handleInputFocusReturn"
                @blur="handleInputBlurReturn"
              />
              <PointComponent
                :value="escort_return.point_destination_escort.street_number"
                title="Civico"
                label="N. civico"
                placeholder="N. civico"
                :disabled="booking.loaner == 'true'"
                @input="(newValue) => (escort_return.point_destination_escort.street_number = newValue)"
                @focus="handleInputFocusReturn"
                @blur="handleInputBlurReturn"
              />
              <PointComponent
                :value="escort_return.point_destination_escort.cap"
                title="CAP"
                label="CAP"
                placeholder="CAP"
                :disabled="booking.loaner == 'true'"
                @input="(newValue) => (escort_return.point_destination_escort.cap = newValue)"
                @focus="handleInputFocusReturn"
                @blur="handleInputBlurReturn"
              />
              <PointComponent
                :value="escort_return.point_destination_escort.city"
                title="Città"
                label="Città"
                placeholder="Città"
                :disabled="booking.loaner == 'true'"
                @input="(newValue) => (escort_return.point_destination_escort.city = newValue)"
                @focus="handleInputFocusReturn"
                @blur="handleInputBlurReturn"
              />
              <PointComponent
                :value="escort_return.point_destination_escort.province"
                title="Provincia"
                label="Provincia"
                placeholder="Provincia"
                :disabled="booking.loaner == 'true'"
                @input="(newValue) => (escort_return.point_destination_escort.province = newValue)"
                @focus="handleInputFocusReturn"
                @blur="handleInputBlurReturn"
              />
            </div>
            <DescriptionComponent
              :label="escort_return.point_destination_escort.label"
              :loading="loadingPoint"
            />

            <div class="fx-stats">
              <span class="fx-stat">
                <span class="fx-stat__l">Fascia km</span>
                <span class="fx-stat__v">{{ kmTesto(responseKmReturn) }}</span>
              </span>
              <span class="fx-stat fx-stat--euro">
                <span class="fx-stat__l">Tariffa</span>
                <span class="fx-stat__v">{{ euroTesto(responseCostReturn) }}</span>
              </span>
            </div>
          </el-form>
        </div>

        <div
          v-else
          class="form-card__off"
        >
          Non incluso in questa prenotazione. Accendilo con l'interruttore.
        </div>
      </section>

      <!-- ---------- lavori di officina ----------
           Decide se esiste la seconda schermata: con «Sì» il pulsante in fondo
           diventa «Avanti», con «No» crea subito. -->
      <section class="form-card">
        <header class="form-card__head">
          <h3>Lavori di officina</h3>
          <div class="form-card__spacer" />
          <span class="form-card__hint">Se sì, si aggiungono nella schermata successiva</span>
        </header>

        <div class="form-card__body">
          <div class="form-sub form-sub--flush">
            <div class="fx-field">
              <span class="campo-label">Il cliente deve pagare dei lavori di officina?</span>
              <el-radio-group
                v-model="task"
                class="fx-radio"
                @change="changeValueTask"
              >
                <el-radio label="true">
                  Sì
                </el-radio>
                <el-radio label="false">
                  No
                </el-radio>
              </el-radio-group>
            </div>

            <div
              v-if="task == 'true'"
              class="fx-field fx-field--auto"
            >
              <SelectComponent
                :options="carsId"
                title="Auto"
                :add-buttom="true"
                :highlight="highlightCar"
                :link-path="`/add-car/${customerSelected}`"
                :is-disabled="customerSelected == ''"
                :span="25"
                :value="carSelected"
                @selected="handleChangeCar"
              />
            </div>
          </div>
        </div>
      </section>

      <!-- ---------- totale e azioni ---------- -->
      <div class="form-actions">
        <div class="form-actions__tot">
          <span class="form-actions__totL">Totale</span>
          <span class="form-actions__totV">{{ totaleFormattato }}</span>
        </div>
        <span class="form-actions__hint">{{ riepilogoTratte }}</span>
        <div class="form-card__spacer" />
        <ButtonComponent
          label="Annulla"
          :is-router="true"
          link-path="/"
          @button-click="annulla"
        />
        <ButtonComponent
          :label="task == 'true' ? 'Avanti' : 'Crea'"
          :is-router="false"
          @button-click="handleButtonClickCrea"
        />
      </div>
    </template>

    <!-- ================= PASSO 2 ================= -->
    <template v-else-if="active === 1">
      <el-form :model="tasks">
        <section class="form-card">
          <header class="form-card__head">
            <h3>Lavori di manutenzione</h3>
          </header>

          <div class="form-card__body">
            <el-scrollbar height="250px">
              <div
                v-for="(task, counter_task) in tasks"
                :key="counter_task"
              >
                <div class="task-row">
                  <AggiungiLavori
                    :highlight-description="highlightDescription"
                    :highlight-cost="highlightCost"
                    @description="(newValue) => (task.description = newValue)"
                    @cost="(newValue) => (task.cost = newValue)"
                    @pay="(newValue) => (task.pay = newValue)"
                  />

                  <div>
                    <ButtonComponent
                      :if-condition="counter_task != 0 ? true : false"
                      :is-router="false"
                      type="danger"
                      icon="Delete"
                      @button-click="rimuoviTask($event, counter_task)"
                    />
                  </div>
                </div>
              </div>
              <ButtonComponent
                label="Aggiungi lavori"
                :is-router="false"
                type="success"
                @button-click="aggiungiTask"
              />
            </el-scrollbar>
          </div>
        </section>

        <section class="form-card">
          <header class="form-card__head">
            <h3>Allegati</h3>
          </header>
          <div class="form-card__body">
            <UploadFile
              label="Carica preventivo"
              @note="handleChangeNote"
              @upload-change="onFileSelected"
            />
          </div>
        </section>

        <div class="form-actions">
          <div class="form-actions__tot">
            <span class="form-actions__totL">Totale</span>
            <span class="form-actions__totV">{{ totaleFormattato }}</span>
          </div>
          <span class="form-actions__hint">{{ riepilogoTratte }}</span>
          <div class="form-card__spacer" />
          <ButtonComponent
            label="Indietro"
            :is-router="false"
            @button-click="back"
          />
          <ButtonComponent
            label="Crea"
            :is-router="false"
            @button-click="onSubmit"
          />
        </div>
      </el-form>
    </template>
  </div>
</template>


<script>
import prenotazioneAPI from '../services/prenotazioneAPI.js';
import store from '../store/prenotazione.js';
import carAPI from '../services/carAPI.js';
import bookingAPI from '@/services/bookingAPI';
import customerAPI from '../services/customerAPI';
import partnerAPI from '@/services/partnerAPI';
import PointComponent from './PointComponent.vue';
import '@vuepic/vue-datepicker/dist/main.css';
import { computed, reactive, ref, toRaw } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Delete } from '@element-plus/icons-vue';
import { isEmpty } from 'lodash';
import { useRouter } from 'vue-router';
import SelectComponent from './SelectComponent.vue';
import { isLoggedStore } from '../store/logged';
import AddNewCustomerComponent from './AddNewCustomerComponent.vue';
import { rottaNuovoCliente } from '../services/servizi.js';
import DateSelectComponent from './DateSelectComponent.vue';
import ButtonComponent from './ButtonComponent.vue';
import DescriptionComponent from './DescriptionComponent.vue';
import AggiungiLavori from './AggiungiLavori.vue';

import UploadFile from './UploadFile';
const dayjs = require('dayjs');

export default {
  name: 'EscortComponent',
  components: {
    AddNewCustomerComponent,
    SelectComponent,
    PointComponent,
    DateSelectComponent,
    ButtonComponent,
    DescriptionComponent,
    AggiungiLavori,
    UploadFile,
  },

  props: {
    // Data scelta nel calendario dell'Agenda, in forma `YYYY-MM-DD`.
    //
    // Arriva come PROP e non leggendo la rotta: la pagina che ospita questo
    // form la conosce gia', e farla leggere anche da qui significherebbe due
    // posti che devono restare d'accordo su un nome di query string.
    // Vuota se non si arriva dall'Agenda: il calendario parte vuoto.
    dataIniziale: {
      type: String,
      default: '',
    },
  },

  setup() {
    const storeLogin = isLoggedStore();

    const router = useRouter();
    const changeValueTask = (val) => {
      task.value = val;
      isAvantiButtonDisabled();
    };

    let task = ref('false');
    const tasks = reactive([
      {
        description: '',
        cost: 0,
        pay: false,
        accepted: false,
      },
    ]);

    const booking = reactive({
      payed: false,
      imponibile: 0,
      tot_fattura: 0,
      // Niente `rif_fattura` alla creazione: «non fatturato» è NULL, e 0
      // verrebbe salvato come un riferimento vero.
      liquidato: false,
      data: new Date(),
      over_twentysix: false,
      loaner: 'true',
      targa_loaner: '',
      state: 'before', //status:"before"
      type: 'both',
      note: '',
      customer: store.customerSelectedObj,
      employee: storeLogin.employee,
      type_prenotazione: 'escort',
      headquarter: store.heaquarterSelectedObj,

      escort_bookings: [],
    });

    /* let tasks= [{
                description: "",
                cost: 0,
                pay: false,
                accepted: true
            }], */

    const escort_gone = reactive({
      date_partner: '',
      date_customer: '',
      date_driver: '',
      date_jolly_scan: '',
      true_date_partner: '',
      true_date_customer: '',
      true_date_driver: '',
      simba_km: 0,
      simba_cost: 0.0,
      simba_minute: 0,
      type_booking: 'gone',
      order: 0,
      tasks: false,
      driver_escort: null,
      planner: null,
      point_origin_escort: {
        address: store.heaquarterSelectedObj.address,
        street_number: store.heaquarterSelectedObj.street_number,
        cap: store.heaquarterSelectedObj.cap,
        city: store.heaquarterSelectedObj.city,
        province: store.heaquarterSelectedObj.province,
        label: '',
        latitude: 0,
        longitude: 0,
        trip: null,
      },
      point_destination_escort: {
        address: store.originPointAddress, //"",
        street_number: store.originPointStreetNumber, //"",
        cap: store.originPointCity, //"",
        city: store.originPointCap, //"",
        province: store.originPointProvince, //"",
        label: '',
        latitude: 0,
        longitude: 0,
        trip: null,
      },
      planners: [],
    });

    const escort_return = reactive({
      date_partner: '',
      new_date_partner: null,
      date_customer: '',
      date_driver: '',
      date_jolly_scan: '',
      true_date_partner: '',
      true_date_customer: '',
      true_date_driver: '',
      simba_km: 0,
      simba_cost: 0.0,
      simba_minute: 0,
      type_booking: 'return',
      order: 0,
      tasks: false,
      driver_escort: null,
      planner: null,
      point_origin_escort: {
        address: store.destinationPointAddress,
        street_number: store.destinationPointStreetNumber,
        cap: store.destinationPointCity,
        city: store.destinationPointCap,
        province: store.destinationPointProvince,
        label: '',
        latitude: 0,
        longitude: 0,
        trip: null,
      },
      point_destination_escort: {
        address: store.heaquarterSelectedObj.address,
        street_number: store.heaquarterSelectedObj.street_number,
        cap: store.heaquarterSelectedObj.cap,
        city: store.heaquarterSelectedObj.city,
        province: store.heaquarterSelectedObj.province,
        label: '',
        latitude: 0,
        longitude: 0,
        trip: null,
      },
      planners: [],
    });

    let customerExist = ref('');

    const checkCustomerExist = async () => {
      try {
        let request = {
          mail: customerExist.value,
        };

        const response = await customerAPI.checkCustomerExist(request);

        if (response.data.exist == true) {
          ElMessageBox.confirm(
            `Nome: ${response.data.customer.name}<br>Cognome: ${response.data.customer.surname}<br>Email: ${response.data.customer.mail}`,
            'Cliente Trovato',
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: 'Aggiungi il cliente',
              cancelButtonText: 'Annulla',
            }
          )
            .then(() => {
              addPartnerToCustomer();
            })
            .catch(() => {});
        } else {
          ElMessageBox.confirm(
            'Il cliente non esiste, registralo prima di prenotare',
            {
              confirmButtonText: 'Registra un cliente',
              cancelButtonText: 'Cancel',
              type: 'warning',
              customClass: 'custom-message-box',
            }
          )
            .then(() => {
              router.push(rottaNuovoCliente('escort', router.currentRoute.value.query.data, customerExist.value));
            })
            .catch(() => {});
        }
      } catch (error) {
        ElMessage({
          message: 'Si è verificato un errore durante la verifica del cliente',
          type: 'error',
        });
        console.error(error);
      }
    };

    const addPartnerToCustomer = async () => {
      const responsePartner = await partnerAPI.getPartnerByEmployee(
        storeLogin.id
      );

      const partner = responsePartner.data[0].headquarters[0].partner;

      try {
        let request = {
          mail: customerExist.value,
          partner: partner,
        };

        const response = await customerAPI.addPartnerToCustomer(request);

        booking.customer = response.data.customer;

        store.customerSelectedObj = response.data.customer;

        const customerExistsInStore = customersId.value.some(
          (customer) => customer.value === response.data.customer.id
        );

        if (!customerExistsInStore) {
          store.customers.push(response.data.customer);
        }

        let tableRow = {
          value: booking.customer.id,
          label: `${booking.customer.name} ${booking.customer.surname}, ${booking.customer.mail}`,
        };
        if (!customerExistsInStore) {
          store.customersCascader.push(tableRow);
        }
        customerSelected.value = response.data.customer.id;

        loadCars(booking.customer.id);
      } catch (error) {
        console.error(error);
      }
    };

    //cliente
    let customerSelected = ref(store.customerSelected);
    const customersId = ref(store.customersCascader);
    const customers = ref(store.customers);

    const customerId = {
      customer_id: '',
    };

    const handleChangeCustomer = async (val) => {
      customerSelected.value = val;

      customerSelected.value = val;
      carsId.value = [];
      booking.customer = customers.value.filter(
        (customer) => customer.id == val
      )[0];

      store.customerSelected = booking.customer.id;
      store.customerSelectedObj = booking.customer;

      escort_gone.point_destination_escort.address = booking.customer.address;
      escort_gone.point_destination_escort.street_number =
        booking.customer.street_number;
      escort_gone.point_destination_escort.cap = booking.customer.cap;
      escort_gone.point_destination_escort.city = booking.customer.city;
      escort_gone.point_destination_escort.province = booking.customer.province;
      escort_gone.point_destination_escort.latitude = booking.customer.latitude;
      escort_gone.point_destination_escort.longitude =
        booking.customer.longitude;

      store.originPointAddress = escort_gone.point_destination_escort.address;
      store.originPointStreetNumber =
        escort_gone.point_destination_escort.street_number;
      store.originPointCity = escort_gone.point_destination_escort.cap;
      store.originPointCap = escort_gone.point_destination_escort.city;
      store.originPointProvince = escort_gone.point_destination_escort.province;

      escort_return.point_origin_escort.address = booking.customer.address;
      escort_return.point_origin_escort.street_number =
        booking.customer.street_number;
      escort_return.point_origin_escort.cap = booking.customer.cap;
      escort_return.point_origin_escort.city = booking.customer.city;
      escort_return.point_origin_escort.province = booking.customer.province;
      escort_return.point_origin_escort.latitude = booking.customer.latitude;
      escort_return.point_origin_escort.longitude = booking.customer.longitude;

      store.destinationPointAddress = escort_return.point_origin_escort.address;
      store.destinationPointStreetNumber =
        escort_return.point_origin_escort.street_number;
      store.destinationPointCity = escort_return.point_origin_escort.cap;
      store.destinationPointCap = escort_return.point_origin_escort.city;
      store.destinationPointProvince =
        escort_return.point_origin_escort.province;

      let resposnePointDestination = await loadPoints(
        escort_gone.point_destination_escort
      );

      escort_gone.point_destination_escort.label =
        resposnePointDestination[0].label;
      escort_gone.point_destination_escort.latitude =
        resposnePointDestination[0].point.latitude;
      escort_gone.point_destination_escort.longitude =
        resposnePointDestination[0].point.longitude;

      let resposnePoinOrigin = await loadPoints(
        escort_return.point_origin_escort
      );

      escort_return.point_origin_escort.label = resposnePoinOrigin[0].label;

      escort_return.point_origin_escort.latitude =
        resposnePoinOrigin[0].point.latitude;

      escort_return.point_origin_escort.longitude =
        resposnePoinOrigin[0].point.longitude;

      customerId.customer_id = val[0];

      loadCars(val[0]);
      isAvantiButtonDisabled();
      calcolaKmGone();
      calcolaKmReturn();
    };

    //macchina

    let carsId = ref([]);
    const cars = ref([]);

    const storecheck = () => {
      if (store.customerSelected) loadCars(store.customerSelected);
    };

    const loadCars = async (customer_id) => {
      try {
        const partner = await partnerAPI.getPartnerByEmployee(
          booking.employee.id
        );
        const response = await carAPI.getCarsByCustomer(
          customer_id,
          partner.data[0].headquarters[0].partner.id
        );
        let tableRow = {};

        response.data.forEach((car) => {
          if (car.minutes.length != 0) {
            car.minutes.forEach((minute) => {
              if (minute.accepted == true) {
                tableRow = {
                  value: car.id,
                  label: `${car.marca} ${car.modello} ${car.targa}`,
                };
                carsId.value.push(tableRow);
                cars.value.push(car);
              }
            });
          } else {
            tableRow = {
              value: car.id,
              label: `${car.marca} ${car.modello} ${car.targa}`,
            };
            carsId.value.push(tableRow);
            cars.value.push(car);
          }
        });
      } catch (error) {
        console.error(error);
      }
    };

    storecheck();
    //macchina
    let carSelected= ref(store.carSelected);

    const handleChangeCar = async (val) => {
      booking.car = cars.value.filter((car) => car.id == val)[0];
      carSelected.value=booking.car.id;

      isAvantiButtonDisabled();
    };

    //partner
    const partnersId = ref([]);
    const partners = ref([]);

    //sede
    let headquarterSelected = ref(store.heaquarterSelected);
    let headquartersId = ref(store.headquartersCascader);
    const headquarters = ref(store.headquarters);

    const response_minute_gone = ref(0);
    const response_minute_return = ref(0);

    const handleChangeHeadquarter = async (val) => {
      headquarterSelected.value = val;
      booking.headquarter = headquarters.value.filter(
        (headquarter) => headquarter.id == val
      )[0];

      store.heaquarterSelected = booking.headquarter.id;
      store.heaquarterSelectedObj = booking.headquarter;

      escort_gone.point_origin_escort.address = booking.headquarter.address;
      escort_gone.point_origin_escort.street_number =
        booking.headquarter.street_number;
      escort_gone.point_origin_escort.cap = booking.headquarter.cap;
      escort_gone.point_origin_escort.city = booking.headquarter.city;
      escort_gone.point_origin_escort.province = booking.headquarter.province;
      escort_gone.point_origin_escort.latitude = booking.headquarter.latitude;
      escort_gone.point_origin_escort.longitude = booking.headquarter.longitude;

      escort_return.point_destination_escort.address =
        booking.headquarter.address;
      escort_return.point_destination_escort.street_number =
        booking.headquarter.street_number;
      escort_return.point_destination_escort.cap = booking.headquarter.cap;
      escort_return.point_destination_escort.city = booking.headquarter.city;
      escort_return.point_destination_escort.province =
        booking.headquarter.province;
      escort_return.point_destination_escort.latitude =
        booking.headquarter.latitude;
      escort_return.point_destination_escort.longitude =
        booking.headquarter.longitude;

      let resposnePointDestination = await loadPoints(
        escort_gone.point_origin_escort
      );

      escort_gone.point_origin_escort.label = resposnePointDestination[0].label;
      escort_gone.point_origin_escort.latitude =
        resposnePointDestination[0].point.latitude;
      escort_gone.point_origin_escort.longitude =
        resposnePointDestination[0].point.longitude;

      let resposnePoinOrigin = await loadPoints(
        escort_return.point_destination_escort
      );

      escort_return.point_destination_escort.label = resposnePoinOrigin[0].label;
      escort_return.point_destination_escort.latitude =
        resposnePoinOrigin[0].point.latitude;
      escort_return.point_destination_escort.longitude =
        resposnePoinOrigin[0].point.longitude;

      calcolaKmGone();
      calcolaKmReturn();
      isAvantiButtonDisabled();
    };

    const pointToString = (point) => {
      const address = point.address ? point.address : '';
      const street_number = point.street_number ? point.street_number : '';
      const city = point.city ? point.city : '';
      const province = point.province ? point.province : '';
      const cap = point.cap ? point.cap : '';

      return (
        address + ' ' + street_number + ' ' + cap + ', ' + city + ' ' + province
      );
    };
    let loadingPoint = ref(true);

    const loadPoints = async (point) => {
      try {
        const response = await prenotazioneAPI.getPoints({
          text: pointToString(point),
        });
        loadingPoint.value = false;
        return response.data;
      } catch (error) {
        console.error(error);
        return [];
      }
    };

    // Pulsante «Avanti» disabilitato finché mancano informazioni.
    let button1_disabled = ref(true);

    const isAvantiButtonDisabled = () => {
      const pickupGone = escort_gone.point_origin_escort;

      const pickupReturn = escort_return.point_destination_escort;

      if (is_return.value && is_gone.value) {
        if (
          (pickupGone.address == '' &&
            pickupGone.street_number == '' &&
            pickupGone.city == '' &&
            pickupGone.province == '' &&
            pickupGone.cap == '') ||
          (pickupReturn.address == '' &&
            pickupReturn.street_number == '' &&
            pickupReturn.city !== '' &&
            pickupReturn.province == '' &&
            pickupReturn.cap == '') ||
          isEmpty(toRaw(booking.customer)) ||
          isEmpty(toRaw(booking.headquarter)) ||
          escort_gone.date_partner == '' ||
          escort_return.date_partner == '' ||
          (task.value == 'true' && isEmpty(toRaw(booking.car)))
        ) {
          button1_disabled.value = true;
        } else {
          button1_disabled.value = false;
        }
      } else if (!is_return.value && is_gone.value) {
        if (
          (pickupGone.address == '' &&
            pickupGone.street_number == '' &&
            pickupGone.city == '' &&
            pickupGone.province == '' &&
            pickupGone.cap == '') ||
          isEmpty(toRaw(booking.customer)) ||
          isEmpty(toRaw(booking.headquarter)) ||
          escort_gone.date_partner == '' ||
          (task.value == 'true' && isEmpty(toRaw(booking.car)))
        ) {
          button1_disabled.value = true;
        } else {
          button1_disabled.value = false;
        }
      } else if (is_return.value && !is_gone.value) {
        if (
          (pickupReturn.address == '' &&
            pickupReturn.street_number == '' &&
            pickupReturn.city == '' &&
            pickupReturn.province == '' &&
            pickupReturn.cap == '') ||
          isEmpty(toRaw(booking.customer)) ||
          isEmpty(toRaw(booking.headquarter)) ||
          escort_return.date_partner == '' ||
          (task.value == 'true' && isEmpty(toRaw(booking.car)))
        ) {
          button1_disabled.value = true;
        } else {
          button1_disabled.value = false;
        }
      }
      return true;
    };

    //scelta di solo andata, solo ritorno o entrambi
    let is_gone = ref(true);
    let is_return = ref(true);

    const deleteGone = () => {
      is_gone.value = !is_gone.value;

      isAvantiButtonDisabled();
    };

    const deleteReturn = () => {
      is_return.value = !is_return.value;
      isAvantiButtonDisabled();
    };

    //ottengo slot disponibili
    const selectedSlotGone = ref(null);
    const selectedSlotReturn = ref(null);
    const timeSlotsGone = ref([
      {
        value: '08:45',
        label: '08:45',
      },
      {
        value: '09:00',
        label: '09:00',
      },
      {
        value: '09:15',
        label: '09:15',
      },
      {
        value: '09:30',
        label: '09:30',
      },
      {
        value: '09:45',
        label: '09:45',
      },
      {
        value: '10:00',
        label: '10:00',
      },
      {
        value: '10:15',
        label: '10:15',
      },
      {
        value: '10:30',
        label: '10:30',
      },

      {
        value: '10:45',
        label: '10:45',
      },
      {
        value: '11:00',
        label: '11:00',
      },
      {
        value: '11:15',
        label: '11:15',
      },
      {
        value: '11:30',
        label: '11:30',
      },

      {
        value: '11:45',
        label: '11:45',
      },
      {
        value: '12:00',
        label: '12:00',
      },
      {
        value: '12:15',
        label: '12:15',
      },
      {
        value: '12:30',
        label: '12:30',
      },
      {
        value: '12:45',
        label: '12:45',
      },
      {
        value: '13:00',
        label: '13:00',
      },
      {
        value: '13:15',
        label: '13:15',
      },
      {
        value: '13:30',
        label: '13:30',
      },
      {
        value: '13:45',
        label: '13:45',
      },
      {
        value: '14:00',
        label: '14:00',
      },
      {
        value: '14:15',
        label: '14:15',
      },
      {
        value: '14:30',
        label: '14:30',
      },
      {
        value: '14:45',
        label: '14:45',
      },
      {
        value: '15:00',
        label: '15:00',
      },
      {
        value: '15:15',
        label: '15:15',
      },
      {
        value: '15:30',
        label: '15:30',
      },
      {
        value: '15:45',
        label: '15:45',
      },
      {
        value: '16:00',
        label: '16:00',
      },
      {
        value: '16:15',
        label: '16:15',
      },
      {
        value: '16:30',
        label: '16:30',
      },
      {
        value: '16:45',
        label: '16:45',
      },
      {
        value: '17:00',
        label: '17:00',
      },
      {
        value: '17:15',
        label: '17:15',
      },
      {
        value: '17:30',
        label: '17:30',
      },
      {
        value: '17:45',
        label: '17:45',
      },
      {
        value: '18:00',
        label: '18:00',
      },
      {
        value: '18:15',
        label: '18:15',
      },
      {
        value: '18:30',
        label: '18:30',
      },
      {
        value: '18:45',
        label: '18:45',
      },
    ]);
    const timeSlotsReturn = ref([
      {
        value: '08:45',
        label: '08:45',
      },
      {
        value: '09:00',
        label: '09:00',
      },
      {
        value: '09:15',
        label: '09:15',
      },
      {
        value: '09:30',
        label: '09:30',
      },
      {
        value: '09:45',
        label: '09:45',
      },
      {
        value: '10:00',
        label: '10:00',
      },
      {
        value: '10:15',
        label: '10:15',
      },
      {
        value: '10:30',
        label: '10:30',
      },

      {
        value: '10:45',
        label: '10:45',
      },
      {
        value: '11:00',
        label: '11:00',
      },
      {
        value: '11:15',
        label: '11:15',
      },
      {
        value: '11:30',
        label: '11:30',
      },

      {
        value: '11:45',
        label: '11:45',
      },
      {
        value: '12:00',
        label: '12:00',
      },
      {
        value: '12:15',
        label: '12:15',
      },
      {
        value: '12:30',
        label: '12:30',
      },
      {
        value: '12:45',
        label: '12:45',
      },
      {
        value: '13:00',
        label: '13:00',
      },
      {
        value: '13:15',
        label: '13:15',
      },
      {
        value: '13:30',
        label: '13:30',
      },
      {
        value: '13:45',
        label: '13:45',
      },
      {
        value: '14:00',
        label: '14:00',
      },
      {
        value: '14:15',
        label: '14:15',
      },
      {
        value: '14:30',
        label: '14:30',
      },
      {
        value: '14:45',
        label: '14:45',
      },
      {
        value: '15:00',
        label: '15:00',
      },
      {
        value: '15:15',
        label: '15:15',
      },
      {
        value: '15:30',
        label: '15:30',
      },
      {
        value: '15:45',
        label: '15:45',
      },
      {
        value: '16:00',
        label: '16:00',
      },
      {
        value: '16:15',
        label: '16:15',
      },
      {
        value: '16:30',
        label: '16:30',
      },
      {
        value: '16:45',
        label: '16:45',
      },
      {
        value: '17:00',
        label: '17:00',
      },
      {
        value: '17:15',
        label: '17:15',
      },
      {
        value: '17:30',
        label: '17:30',
      },
      {
        value: '17:45',
        label: '17:45',
      },
      {
        value: '18:00',
        label: '18:00',
      },
      {
        value: '18:15',
        label: '18:15',
      },
      {
        value: '18:30',
        label: '18:30',
      },
      {
        value: '18:45',
        label: '18:45',
      },
    ]);

    const handleChangeDateGone = async (val) => {
      try {
        escort_gone.date_partner = val;
        const selectedDate = dayjs(escort_gone.date_partner).format(
          'YYYY-MM-DD'
        );
        await loadSlotGone(selectedDate);
      } catch (error) {
        console.error(error);
      }
    };

    const handleChangeDateReturn = async (val) => {
      try {
        escort_return.date_partner = val;
        const selectedDate = dayjs(escort_return.date_partner).format(
          'YYYY-MM-DD'
        );
        await loadSlotReturn(selectedDate);
      } catch (error) {
        console.error(error);
      }
    };

    let loadingSlotsGone = ref(true);
    let loadingSlotsReturn = ref(true);

    let request_slot_gone = {
      originPoint: {},
      destinationPoint: {},
      partnerDay: new Date(),
      type: '',
      area: '',
    };
    const SlotGone = async (date) => {
      loadingSlotsGone.value = true;
      let newSlot = '';
      handleSlotChangeGone(newSlot);

      try {
        if (
          !isEmpty(toRaw(escort_gone.point_origin_escort)) &&
          !isEmpty(toRaw(escort_gone.point_destination_escort))
        ) {
          if (booking.loaner == 'false') {
            request_slot_gone.originPoint = toRaw(
              escort_gone.point_origin_escort
            );

            request_slot_gone.destinationPoint = toRaw(
              escort_gone.point_destination_escort
            );
            request_slot_gone.type = 'ESCORT_GONE';
            request_slot_gone.partnerDay = date;
          } else {
            request_slot_gone.originPoint = toRaw(
              escort_gone.point_origin_escort
            );
            request_slot_gone.destinationPoint = toRaw(
              escort_gone.point_destination_escort
            );
            request_slot_gone.type = 'ESCORT_AUTO_GONE';
            request_slot_gone.partnerDay = date;
          }
          request_slot_gone.area = booking.headquarter.area;
          request_slot_gone.headquarterId = booking.headquarter.id;
          const response = await prenotazioneAPI.calcSlot(request_slot_gone);
          loadingSlotsGone.value = false;
          return response.data;
        }
      } catch (error) {
        console.error('Error loading slots:', error);
        return null;
      }
    };
    let request_slot_return = {
      originPoint: {},
      destinationPoint: {},
      partnerDay: new Date(),
      type: '',
      area: '',
    };
    const SlotReturn = async (date) => {
      loadingSlotsReturn.value = true;
      let newSlot = '';
      handleSlotChangeReturn(newSlot);
      try {
        if (
          !isEmpty(toRaw(escort_return.point_origin_escort)) &&
          !isEmpty(toRaw(escort_return.point_destination_escort))
        ) {
          if (booking.loaner == 'false') {
            request_slot_return.originPoint = toRaw(
              escort_return.point_destination_escort
            );
            request_slot_return.destinationPoint = toRaw(
              escort_return.point_origin_escort
            );
            request_slot_return.type = 'ESCORT_RETURN';
            request_slot_return.partnerDay = date;
          } else {
            request_slot_return.originPoint = toRaw(
              escort_return.point_destination_escort
            );
            request_slot_return.destinationPoint = toRaw(
              escort_return.point_origin_escort
            );
            request_slot_return.type = 'ESCORT_AUTO_RETURN';
            request_slot_return.partnerDay = date;
          }
          request_slot_return.area = booking.headquarter.area;
          request_slot_return.headquarterId = booking.headquarter.id;
          const response = await prenotazioneAPI.calcSlot(request_slot_return);
          loadingSlotsReturn.value = false;
          return response.data;
        }
      } catch (error) {
        console.error('Error loading slots:', error);
        return null;
      }
    };

    const mergeSlotsGone = async (timeSlots, selectedDate) => {
      // 1: carico slot disponibili dal backend
      const availableSlots = await SlotGone(selectedDate);
      if (availableSlots) {
        // 2: seleziono gli slot disponibili
        const mergedSlots = timeSlots.map((timeSlot) => {
          const isAvailable = availableSlots.includes(timeSlot.value);
          return {
            ...timeSlot,
            disabled: !isAvailable,
          };
        });
        return mergedSlots;
      }
      return [];
    };

    const mergeSlotsReturn = async (timeSlots, selectedDate) => {
      // 1: carico slot disponibili dal backend
      const availableSlots = await SlotReturn(selectedDate);
      if (availableSlots) {
        // 2: seleziono gli slot disponibili
        const mergedSlots = timeSlots.map((timeSlot) => {
          let isAvailable = availableSlots.includes(timeSlot.value);
          const [hour, minute] = timeSlot.value.split(':').map(Number);

          const newDate = dayjs(selectedDate)
            .hour(hour)
            .minute(minute)
            .second(0)
            .toDate();

          isAvailable =
            isAvailable && is_gone.value
              ? new Date(newDate).getTime() >
                new Date(escort_gone.date_partner).getTime()
              : isAvailable;

          return {
            ...timeSlot,
            disabled: !isAvailable,
          };
        });
        return mergedSlots;
      }
      return [];
    };

    const loadSlotGone = async (selectedDate) => {
      if (selectedDate != '') {
        const mergedSlotsGone = await mergeSlotsGone(
          timeSlotsGone.value,
          selectedDate
        );
        timeSlotsGone.value.splice(
          0,
          timeSlotsGone.value.length,
          ...mergedSlotsGone
        );
      }
    };

    const loadSlotReturn = async (selectedDate) => {
      if (selectedDate != '') {
        const mergedSlotsReturn = await mergeSlotsReturn(
          timeSlotsReturn.value,
          selectedDate
        );
        timeSlotsReturn.value.splice(
          0,
          timeSlotsReturn.value.length,
          ...mergedSlotsReturn
        );
      }
    };

    const handleSlotChangeGone = (value) => {
      selectedSlotGone.value = value;
      if (value != '') {
        escort_gone.date_partner = dayjs(escort_gone.date_partner)
          .hour(value[0].split(':')[0])
          .minute(value[0].split(':')[1])
          .second(0)
          .toISOString();
      } else {
        return '';
      }
      isAvantiButtonDisabled();
    };

    const handleSlotChangeReturn = (value) => {
      selectedSlotReturn.value = value;
      if (value != '') {
        escort_return.date_partner = dayjs(new Date(escort_return.date_partner))
          .hour(value[0].split(':')[0])
          .minute(value[0].split(':')[1])
          .second(0)
          .toISOString();
      } else {
        return '';
      }
      isAvantiButtonDisabled();
    };

    //scelta dell'auto di cortesia da fornire al cliente
    const changeLoaner = (val) => {
      booking.loaner = val;

      if (is_gone.value && is_return.value) {
        calcolaKmGone();
        calcolaKmReturn();

        if (escort_gone.date_partner != '')
          loadSlotGone(escort_gone.date_partner);
        if (escort_return.date_partner != '')
          loadSlotReturn(escort_return.date_partner);
      } else if (is_gone.value && !is_return.value) {
        calcolaKmGone();
        selectedSlotGone.value = null;
        if (escort_gone.date_partner != '')
          loadSlotGone(escort_gone.date_partner);
      } else if (!is_gone.value && is_return.value) {
        calcolaKmReturn();
        selectedSlotReturn.value = null;
        if (escort_return.date_partner != '')
          loadSlotReturn(escort_return.date_partner);
      }
    };

    let button2_disabled = ref(true);
    //gestione step della prenotazione
    let active = ref(0);

    let highlightCustomer = ref(false);
    let highlightHeadquarter = ref(false);
    let highlightCar = ref(false);

    let highlightDateGone = ref(false);
    let highlightDateReturn = ref(false);
    let highlightSlotGone = ref(false);
    let highlightSlotReturn = ref(false);

    const checkHighlight = () => {
      if (!customerSelected.value) {
        ElMessage.error('Perfavore inserisci un cliente');
        highlightCustomer.value = true;
        return false;
      } else if (!headquarterSelected.value) {
        ElMessage.error('Perfavore inserisci una sede');
        highlightHeadquarter.value = true;
        return false;
      } else if (is_gone.value && escort_gone.date_partner == '') {
        ElMessage.error('Perfavore inserisci una data');
        highlightDateGone.value = true;
        return false;
      } else if (is_gone.value && !selectedSlotGone.value) {
        ElMessage.error('Perfavore inserisci un orario');
        highlightSlotGone.value = true;
        return false;
      } else if (is_return.value && escort_return.date_partner == '') {
        ElMessage.error('Perfavore inserisci una data');
        highlightDateReturn.value = true;
        return false;
      } else if (is_return.value && !selectedSlotReturn.value) {
        ElMessage.error('Perfavore inserisci un orario');
        highlightSlotReturn.value = true;
        return false;
      }

      highlightCustomer.value = false;
      highlightHeadquarter.value = false;
      highlightDateGone.value = false;
      highlightDateReturn.value = false;
      highlightSlotGone.value = false;
      highlightSlotReturn.value = false;
      return true;
    };

    const next = () => {
      if (checkHighlight()) {
        if (active.value++ > 1) {
          active.value = 0;
        }
      }
    };

    //upload file
    let selectedFile1 = null;
    let fd = new FormData();
    const onFileSelected = (e) => {
      for (let file of e.target.files) {
        selectedFile1 = file;
        fd.append('files', selectedFile1, selectedFile1.name);
      }
      return fd;
    };

    const fileLoad = async (fd) => {
      try {
        const mail = booking.customer.mail;
        await prenotazioneAPI.upload(fd, mail);
      } catch (e) {
        console.error(e);
      }
    };

    //range del booking
    let responseKmGone = ref(store.rangeKmGoneEscort);
    let responseKmReturn = ref(store.rangeKmReturnEscort);
    let responseCostGone = ref(store.rangeCostGoneEscort);
    let responseCostReturn = ref(store.rangeCostReturnEscort);

    // -------------------------------------------------------------------
    //  TOTALE, RIEPILOGO E PASTIGLIE — stessi criteri della scheda Pickup.
    //  Si sommano solo le tratte incluse. `Number(...)` con ripiego a 0:
    //  questi ref nascono dallo store e possono contenere stringhe.
    // -------------------------------------------------------------------
    const importo = (v) => {
      const n = Number(v);
      return Number.isFinite(n) ? n : 0;
    };

    const totale = computed(
      () => (is_gone.value ? importo(responseCostGone.value) : 0)
        + (is_return.value ? importo(responseCostReturn.value) : 0)
    );

    const totaleFormattato = computed(
      () => `${totale.value.toFixed(2).replace('.', ',')} €`
    );

    const riepilogoTratte = computed(() => {
      const tratte = [];
      if (is_gone.value) tratte.push('andata');
      if (is_return.value) tratte.push('ritorno');
      if (!tratte.length) return 'Nessuna tratta inclusa';
      const km = (is_gone.value ? importo(responseKmGone.value) : 0)
        + (is_return.value ? importo(responseKmReturn.value) : 0);
      const parte = tratte.join(' e ');
      const Parte = `${parte.charAt(0).toUpperCase()}${parte.slice(1)}`;
      return km > 0 ? `${Parte} · ${km.toFixed(2).replace('.', ',')} km` : Parte;
    });

    // Finché non c'è un numero vero si scrive «—» invece di «0 km» o «0 euro».
    const kmTesto = (v) => {
      const n = importo(v);
      return n > 0 ? `${String(n).replace('.', ',')} km` : '—';
    };

    const euroTesto = (v) => {
      const n = importo(v);
      return n > 0 ? `${n.toFixed(2).replace('.', ',')} €` : '—';
    };

    let request = {
      headquarter_id: '',
      origins_point: {},
      destination_point: '',
      loaner: false,
      area: booking.headquarter.area,
    };

    const calcolaKmGone = async () => {
      try {
        request.headquarter_id = booking.headquarter.id;
        request.origins_point = toRaw(escort_gone.point_origin_escort);
        request.destination_point = toRaw(escort_gone.point_destination_escort);
        request.loaner = booking.loaner.toLowerCase() === 'true';

        if (
          !isEmpty(toRaw(booking.headquarter))
        ) {
          const response = await bookingAPI.getRangeEscort(request);
          escort_gone.simba_minute = response.data.minute;
          escort_gone.simba_km = response.data.km;
          escort_gone.simba_imponibile = response.data.imponibile;
          escort_gone.simba_km_range = response.data.kmRange;

          responseKmGone.value = response.data.kmRange;
          responseCostGone.value = response.data.cost;

          store.rangeKmGoneEscort = response.data.kmRange;
          store.rangeCostGoneEscort = response.data.cost;

        }
      } catch (error) {
        console.error(error);
      }
    };
    calcolaKmGone();

    const calcolaKmReturn = async () => {
      request.headquarter_id = booking.headquarter.id;
      request.origins_point = toRaw(escort_return.point_origin_escort);
      request.destination_point = toRaw(escort_return.point_destination_escort);
      request.loaner = booking.loaner.toLowerCase() === 'true';

      if (
        !isEmpty(toRaw(booking.headquarter))
      ) {
        const response = await bookingAPI.getRangeEscort(request);

        escort_return.simba_minute = response.data.minute;
        escort_return.simba_km = response.data.km;
        escort_return.simba_imponibile = response.data.imponibile;
        escort_return.simba_km_range = response.data.kmRange;

        responseKmReturn.value = response.data.kmRange;
        responseCostReturn.value = response.data.cost;

        store.rangeKmReturnEscort = response.data.kmRange;
        store.rangeCostReturnEscort = response.data.cost;

      }
    };
    calcolaKmReturn();

    isAvantiButtonDisabled();

    const rimuoviTask = (e, counter) => {
      tasks.splice(counter, 1);
      e.preventDefault();
    };

    const aggiungiTask = (e) => {
      tasks.push({
        description: '',
        cost: 0,
        pay: false,
      });
      e.preventDefault();
    };

    const handleButtonClickCrea = () => {
      if (task.value == 'true') {
        next();
      } else {
        onSubmit(booking);
      }
    };

    const addBookingNew = async (booking) => {
      let response = {};
      try {
        // Dopo un tentativo fallito si resta sul form: senza questo reset il
        // secondo invio ripartirebbe con le tratte e i planner gia' accodati
        // dal primo, creando un booking con gambe duplicate.
        booking.escort_bookings.splice(0);
        escort_gone.planners.splice(0);
        escort_return.planners.splice(0);

        booking.loaner =
          typeof booking.loaner === 'string'
            ? booking.loaner.toLowerCase() === 'true'
            : booking.loaner === true;

        if (task.value == 'true') {
          booking.tasks = tasks;

          if (!checkTask()) {
            return;
          }
        }

        if (booking.loaner) {
          booking.type_prenotazione = 'escort_loaner';
        }

        let newPlannerGone = null;
        let newPlannerReturn = null;

        if (is_gone.value && is_return.value) {
          booking.type = 'both';
          booking.imponibile =
            escort_gone.simba_imponibile + escort_return.simba_imponibile;
          booking.tot_fattura = booking.imponibile * 1.22;

          booking.data = escort_gone.date_partner;

          escort_gone.tasks = task.value.toLowerCase() === 'true';
          escort_return.tasks = task.value.toLowerCase() === 'true';

          if (booking.loaner) {
            newPlannerGone = await addPlannerNew(
              toRaw(escort_gone.point_origin_escort),
              toRaw(escort_gone.point_destination_escort),
              escort_gone.date_partner,
              'ESCORT_AUTO_GONE'
            );
            escort_gone.planners.push(newPlannerGone.data.plannerDriver);

            newPlannerReturn = await addPlannerNew(
              toRaw(escort_return.point_origin_escort),
              toRaw(escort_return.point_destination_escort),
              escort_return.date_partner,
              'ESCORT_AUTO_RETURN'
            );
            escort_return.planners.push(newPlannerReturn.data.plannerDriver);

            escort_gone.date_customer =
              newPlannerGone.data.driver.trips[0].dateStart;
            escort_return.date_customer =
              newPlannerReturn.data.driver.trips[0].dateStart;
          } else {
            newPlannerGone = await addPlannerNew(
              toRaw(escort_gone.point_origin_escort),
              toRaw(escort_gone.point_destination_escort),
              escort_gone.date_partner,
              'ESCORT_GONE'
            );
            escort_gone.planners.push(newPlannerGone.data.plannerDriver);
            escort_gone.planners.push(newPlannerGone.data.plannerJolly);

            newPlannerReturn = await addPlannerNew(
              toRaw(escort_return.point_origin_escort),
              toRaw(escort_return.point_destination_escort),
              escort_return.date_partner,
              'ESCORT_RETURN'
            );
            escort_return.planners.push(newPlannerReturn.data.plannerDriver);
            escort_return.planners.push(newPlannerReturn.data.plannerJolly);

            escort_gone.date_customer =
              newPlannerGone.data.driver.trips[0].dateStart;
            escort_return.date_customer =
              newPlannerReturn.data.driver.trips[0].dateStart;
          }


          booking.escort_bookings.push(escort_gone);
          booking.escort_bookings.push(escort_return);
        } else if (is_gone.value && !is_return.value) {
          booking.type = 'gone';
          booking.data = escort_gone.date_partner;
          escort_gone.tasks = task.value.toLowerCase() === 'true';
          booking.imponibile = escort_gone.simba_imponibile;
          booking.tot_fattura = booking.imponibile * 1.22;

          if (booking.loaner) {
            newPlannerGone = await addPlannerNew(
              toRaw(escort_gone.point_origin_escort),
              toRaw(escort_gone.point_destination_escort),
              escort_gone.date_partner,
              'ESCORT_AUTO_GONE'
            );
            escort_gone.planners.push(newPlannerGone.data.plannerDriver);
            escort_gone.date_customer =
              newPlannerGone.data.driver.trips[0].dateStart;
          } else {
            newPlannerGone = await addPlannerNew(
              toRaw(escort_gone.point_origin_escort),
              toRaw(escort_gone.point_destination_escort),
              escort_gone.date_partner,
              'ESCORT_GONE'
            );
            escort_gone.planners.push(newPlannerGone.data.plannerDriver);
            escort_gone.planners.push(newPlannerGone.data.plannerJolly);

            escort_gone.date_customer =
              newPlannerGone.data.driver.trips[0].dateStart;
          }


          booking.escort_bookings.push(escort_gone);
        } else if (!is_gone.value && is_return.value) {
          booking.type = 'return';
          booking.data = escort_return.date_partner;
          escort_return.tasks = task.value.toLowerCase() === 'true';
          booking.imponibile = escort_return.simba_imponibile;
          booking.tot_fattura = booking.imponibile * 1.22;

          if (booking.loaner) {
            newPlannerReturn = await addPlannerNew(
              toRaw(escort_return.point_origin_escort),
              toRaw(escort_return.point_destination_escort),
              escort_return.date_partner,
              'ESCORT_AUTO_RETURN'
            );
            escort_return.planners.push(newPlannerReturn.data.plannerDriver);

            escort_return.date_customer =
              newPlannerReturn.data.driver.trips[0].dateStart;
          } else {
            newPlannerReturn = await addPlannerNew(
              toRaw(escort_return.point_origin_escort),
              toRaw(escort_return.point_destination_escort),
              escort_return.date_partner,
              'ESCORT_RETURN'
            );
            escort_return.planners.push(newPlannerReturn.data.plannerDriver);
            escort_return.planners.push(newPlannerReturn.data.plannerJolly);

            escort_return.date_customer =
              newPlannerReturn.data.driver.trips[0].dateStart;
          }

          booking.escort_bookings.push(escort_return);
        }

        response = await prenotazioneAPI.addBooking(booking);

        // La notifica e' best-effort: il booking e' gia' stato creato, quindi
        // un errore qui non deve far dire "creazione fallita" (l'utente
        // riproverebbe e ne creerebbe un secondo).
        try {
          await prenotazioneAPI.addBookingNotification({
            customer: booking.customer,
            booking: response.data,
            area: booking.headquarter.area,
          });
        } catch (notifyError) {
          console.error('Notifica nuovo booking fallita', notifyError);
        }

        return response;
      } catch (error) {
        notifyBookingError(error);
        console.error('addBookingNew', error);
        return null;
      }
    };

    /** Mostra l'errore solo se non l'ha gia' mostrato l'interceptor di API.js
     *  (che gestisce tutti gli status HTTP): evita il doppio toast. */
    const notifyBookingError = (error) => {
      if (error?.isAxiosError || error?.response) return;
      ElMessage({
        message:
          error?.message || 'Errore durante la creazione della prenotazione',
        type: 'error',
      });
    };

    const addPlannerNew = async (
      originPoint,
      destinationPoint,
      partnerTime,
      type
    ) => {
      const data = {
        originPoint: originPoint,
        destinationPoint: destinationPoint,
        partnerTime: partnerTime,
        type: type,
        area: booking.headquarter.area,
        // Con l'id della sede il backend cerca i driver per provincia.
        headquarterId: booking.headquarter.id,
        // Assegnazione MANUALE, come nel gestionale admin: il motore calcola
        // gli orari e verifica la copertura, ma i planner nascono senza driver.
        assign: false,
      };

      const response = await prenotazioneAPI.calcDuration(data);

      // ATTENZIONE: /planner/best-driver NON usa gli status HTTP. Quando non
      // trova un driver risponde 200 con { error: "No drivers available..." }.
      // Senza questo controllo quel payload proseguiva come se fosse un
      // planner valido e la creazione esplodeva su `data.driver.trips`.
      if (response?.data?.error || !response?.data?.driver) {
        throw new Error(
          response?.data?.error === 'No drivers available for this hour'
            ? "Nessun driver disponibile per l'orario scelto: scegli un altro slot."
            : response?.data?.error ||
              'Il planner non ha restituito un driver: prenotazione non creata.'
        );
      }

      return response;
    };

    let highlightDescription = ref(false);
    let highlightCost = ref(false);

    const checkTask = () => {
      for (let task of booking.tasks) {
        if (task.description == '') {
          ElMessage.error('Perfavore inserisci una descrizione dei lavori');
          highlightDescription.value = true;
          return false;
        }

        if (!task.cost) {
          ElMessage.error('Perfavore inserisci un costo dei lavori');
          highlightCost.value = true;
          return false;
        }

        const floatRegex = /^-?\d+(\.\d+)?$/;
        if (!floatRegex.test(task.cost)) {
          highlightCost.value = true;
          ElMessage.error('Perfavore inserisci un costo valido');
          return false;
        }
        if (task.cost.includes(',')) {
          highlightCost.value = true;
          ElMessage.error('Perfavore non usare virgole per il costo');
          return false;
        }

        highlightDescription.value = false;
        highlightCost.value = false;
      }
      return true;
    };

    const onSubmit = async () => {
      if (!checkHighlight()) {
        return;
      }

      const response = await addBookingNew(toRaw(booking));

      // In caso di fallimento addBookingNew restituisce null e ha gia' mostrato
      // il messaggio: si RESTA sul form, i dati inseriti non si perdono.
      if (response?.status !== 201) {
        return;
      }

      if (selectedFile1 !== null) {
        await fileLoad(fd);
      } else {
        await prenotazioneAPI.mailCustomer(booking.customer.mail);
      }

      router.push('/');
      ElMessage({
        message: 'Booking aggiunto!',
        type: 'success',
      });
    };

    const props1 = {
      expandTrigger: 'hover',
    };

    const isInputFocused = ref(false);

    const handleInputFocusGone = () => {
      isInputFocused.value = true;
    };
    const handleInputBlurGone = async () => {
      isInputFocused.value = false;
      if (
        escort_gone.point_origin_escort.address == '' ||
        escort_gone.point_origin_escort.street_number == '' ||
        escort_gone.point_origin_escort.city == '' ||
        escort_gone.point_origin_escort.cap == '' ||
        escort_gone.point_origin_escort.province == '' ||
        escort_gone.point_destination_escort.address == '' ||
        escort_gone.point_destination_escort.street_number == '' ||
        escort_gone.point_destination_escort.city == '' ||
        escort_gone.point_destination_escort.cap == '' ||
        escort_gone.point_destination_escort.province == ''
      ) {
        button1_disabled.value = true; 
      } else {
        button1_disabled.value = false;
        selectedSlotGone.value = null;

        store.originPointAddress = escort_gone.point_destination_escort.address;
        store.originPointStreetNumber =
          escort_gone.point_destination_escort.street_number;
        store.originPointCity = escort_gone.point_destination_escort.city;
        store.originPointCap = escort_gone.point_destination_escort.cap;
        store.originPointProvince =
          escort_gone.point_destination_escort.province;

        loadSlotGone(escort_gone.date_partner);
        calcolaKmGone();

        let resposnePointDestination = await loadPoints(
          escort_gone.point_destination_escort
        );

        escort_gone.point_destination_escort.label =
          resposnePointDestination.label;
        escort_gone.point_destination_escort.latitude =
          resposnePointDestination.point.latitude;
        escort_gone.point_destination_escort.longitude =
          resposnePointDestination.point.longitude;
      }
    };

    const handleInputFocusReturn = () => {
      isInputFocused.value = true;
    };
    const handleInputBlurReturn = async () => {
      isInputFocused.value = false;
      if (
        escort_return.point_origin_escort.address == '' ||
        escort_return.point_origin_escort.street_number == '' ||
        escort_return.point_origin_escort.city == '' ||
        escort_return.point_origin_escort.cap == '' ||
        escort_return.point_origin_escort.province == '' ||
        escort_return.point_destination_escort.address == '' ||
        escort_return.point_destination_escort.street_number == '' ||
        escort_return.point_destination_escort.city == '' ||
        escort_return.point_destination_escort.cap == '' ||
        escort_return.point_destination_escort.province == ''
      ) {
        button1_disabled.value = true;
      } else {
        selectedSlotReturn.value = null;

        loadSlotReturn(escort_return.date_partner);

        let resposnePoinOrigin = await loadPoints(
          escort_return.point_origin_escort
        );
        store.originPointAddress = escort_return.point_origin_escort.address;
        store.originPointStreetNumber =
          escort_return.point_origin_escort.street_number;
        store.originPointCity = escort_return.point_origin_escort.city;
        store.originPointCap = escort_return.point_origin_escort.cap;
        store.originPointProvince = escort_return.point_origin_escort.province;

        escort_return.point_origin_escort.label = resposnePoinOrigin.label;
        escort_return.point_origin_escort.latitude =
          resposnePoinOrigin.point.latitude;
        escort_return.point_origin_escort.longitude =
          resposnePoinOrigin.point.longitude;

        calcolaKmReturn();
      }
    };

    const back = () => {
      active.value = 0;
    };

    // Il partner inserisce da oggi in poi: i giorni passati li registra Simba.
    const disabledDate = (vDate) => dayjs(vDate).isBefore(dayjs(), 'day');

    const disabledDateReturn = (vDate) => {
      if (is_gone.value && escort_gone.date_partner) {
        return dayjs(vDate).isBefore(dayjs(escort_gone.date_partner), 'day');
      }
      return disabledDate(vDate);
    };

    const handleChangeNote = (value) => {
      booking.value.note = value;
    };

    return {
      totaleFormattato,
      riepilogoTratte,
      kmTesto,
      euroTesto,
      handleChangeNote,
      loadingSlotsGone,
      loadingSlotsReturn,
      back,
      handleInputFocusGone,
      handleInputBlurGone,
      handleInputFocusReturn,
      handleInputBlurReturn,
      fileLoad,
      handleButtonClickCrea,
      headquarterSelected,
      customerSelected,
      carSelected,
      handleChangeDateGone,
      handleChangeDateReturn,
      task,
      escort_gone,
      escort_return,
      changeLoaner,
      deleteGone,
      is_gone,
      deleteReturn,
      is_return,
      selectedSlotGone,
      selectedSlotReturn,
      timeSlotsGone,
      timeSlotsReturn,
      handleSlotChangeGone,
      handleSlotChangeReturn,

      changeValueTask,

      onFileSelected,
      active,
      next,
      tasks,
      loadCars,
      addBookingNew,
      customerId,
      customers,
      customersId,
      booking,
      partners,
      partnersId,
      carsId,
      headquartersId,
      headquarters,
      onSubmit,
      props1,
      handleChangeCar,
      handleChangeCustomer,
      handleChangeHeadquarter,
      aggiungiTask,
      rimuoviTask,
      Delete,
      button1_disabled,
      button2_disabled,

      response_minute_gone,
      response_minute_return,

      calcolaKmGone,
      calcolaKmReturn,
      responseKmGone,
      responseCostGone,
      responseKmReturn,
      responseCostReturn,

      highlightCustomer,
      highlightHeadquarter,
      highlightCar,
      highlightDateGone,
      highlightDateReturn,
      highlightSlotGone,
      highlightSlotReturn,

      DescriptionComponent,
      loadingPoint,

      customerExist,
      checkCustomerExist,
      disabledDate,
      disabledDateReturn,
      highlightDescription,
      highlightCost,
    };
  },
};
</script>

<style scoped>
/* Il layout della scheda è in `styles/forms.css`, condiviso con Pickup. */
</style>
